import { render, staticRenderFns } from "./RequestTypesButtons.vue?vue&type=template&id=534b42c5&scoped=true&"
import script from "./RequestTypesButtons.vue?vue&type=script&lang=js&"
export * from "./RequestTypesButtons.vue?vue&type=script&lang=js&"
import style0 from "./RequestTypesButtons.vue?vue&type=style&index=0&id=534b42c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534b42c5",
  null
  
)

export default component.exports